<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-user"></i> 职工信息</span>
      </div>

      <!-- 查询区域 -->
      <el-form
        :model="queryParams"
        label-position="right"
        label-width="50px"
        style="margin-bottom: 20px"
      >
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="部门">
              <el-input
                v-model="queryParams.departmentName"
                placeholder="请输入部门"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="姓名">
              <el-input
                v-model="queryParams.name"
                placeholder="请输入姓名"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="职务">
              <el-input
                v-model="queryParams.roleName"
                placeholder="请输入职务"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <div>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
          >
            搜索
          </el-button>
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="openAddDialog">
            新增
          </el-button>
        </div>
      </el-form>

      <!-- 表格区域 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column label="姓名" prop="name" />
        <el-table-column label="联系电话" prop="mobile" />
        <el-table-column label="职务" prop="roleName" />
        <el-table-column label="部门" prop="departmentName" />
        <el-table-column label="绑定状态">
          <template slot-scope="scope">
            {{ scope.row.openId ? "已绑定" : "未绑定" }}
          </template>
        </el-table-column>
        <el-table-column label="入职时间" prop="joiningTime" />
        <el-table-column label="最后登录时间" prop="lastLoginTime" />
        <el-table-column label="操作" width="330">
          <template v-slot="scope">
            <el-button
              type="success"
              size="mini"
              @click="setPassword(scope.row)"
              >重置密码</el-button
            >
            <el-button
              :disabled="!scope.row.openId"
              :type="scope.row.openId ? 'warning' : ''"
              size="mini"
              @click="unbind(scope.row)"
              >解绑</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="openEditDialog(scope.row)"
              >编辑</el-button
            >
            <el-button type="danger" size="mini" @click="deleteUser(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页组件 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />

      <!-- 新增/编辑弹窗 -->
      <el-dialog
        @close="resetForm"
        class="custom-dialog"
        :visible.sync="dialogVisible"
        :title="isEdit ? '编辑员工信息' : '新增员工信息'"
        width="600px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="formData"
          ref="form"
          :rules="rules"
          label-width="120px"
        >
          <el-form-item label="姓名" prop="name">
            <el-input
              v-model="formData.name"
              placeholder="请输入姓名"
              style="width: 350px"
            />
          </el-form-item>

          <el-form-item label="职务" prop="roleId">
            <el-select
              v-model="formData.roleId"
              placeholder="请选择职务"
              style="width: 350px"
            >
              <el-option
                v-for="item in positionOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="部门" prop="deptId">
            <el-select
              v-model="formData.deptId"
              placeholder="请选择部门"
              style="width: 350px"
            >
              <el-option
                v-for="item in departmentList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="性别" prop="sex">
            <el-radio-group v-model="formData.sex">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="身份证号" prop="cardNo">
            <el-input
              v-model="formData.cardNo"
              placeholder="请输入身份证号"
              style="width: 350px"
            />
          </el-form-item>

          <el-form-item label="民族" prop="ethnic">
            <el-select
              v-model="formData.ethnic"
              placeholder="请选择民族"
              style="width: 350px"
            >
              <el-option
                v-for="item in ethnicGroups"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="出生年月" prop="birthday">
            <el-date-picker
              v-model="formData.birthday"
              type="date"
              placeholder="选择日期"
              style="width: 350px"
            />
          </el-form-item>

          <el-form-item label="入职时间" prop="joiningTime">
            <el-date-picker
              v-model="formData.joiningTime"
              type="date"
              placeholder="选择入职时间"
              style="width: 350px"
            />
          </el-form-item>

          <el-form-item label="联系电话" prop="mobile">
            <el-input
              v-model="formData.mobile"
              placeholder="请输入联系电话"
              style="width: 350px"
            />
          </el-form-item>

          <el-form-item label="毕业院校" prop="graduateSchool">
            <el-input
              v-model="formData.graduateSchool"
              placeholder="请输入毕业院校"
              style="width: 350px"
            />
          </el-form-item>

          <el-form-item label="专业" prop="major">
            <el-input
              v-model="formData.major"
              placeholder="请输入专业"
              style="width: 350px"
            />
          </el-form-item>

          <el-form-item label="学历" prop="education">
            <el-select
              v-model="formData.education"
              placeholder="请选择学历"
              style="width: 350px"
            >
              <el-option label="博士" value="博士"></el-option>
              <el-option label="硕士" value="硕士"></el-option>
              <el-option label="本科" value="本科"></el-option>
              <el-option label="专科" value="专科"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="普通话等级" prop="mandarinLevel">
            <el-select
              v-model="formData.mandarinLevel"
              placeholder="请选择普通话等级"
              style="width: 350px"
            >
              <el-option label="一甲" value="一甲"></el-option>
              <el-option label="一乙" value="一乙"></el-option>
              <el-option label="二甲" value="二甲"></el-option>
              <el-option label="二乙" value="二乙"></el-option>
              <el-option label="三甲" value="三甲"></el-option>
              <el-option label="三乙" value="三乙"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="密码" prop="password" v-if="!isEdit">
            <el-input
              v-model="formData.password"
              placeholder="请输入密码"
              show-password
              style="width: 350px"
            />
          </el-form-item>

          <el-form-item label="是否维修人员" prop="isRepair">
            <el-radio-group v-model="formData.isRepair">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="是否分配主任" prop="isAllocation">
            <el-radio-group v-model="formData.isAllocation">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="状态" prop="state">
            <el-radio-group v-model="formData.state">
              <el-radio :label="1">正常</el-radio>
              <el-radio :label="0">隐匿</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- 使用公共上传组件上传不同的证书 -->
          <upload-field
            label="毕业证书"
            prop="diploma"
            :fileList="formData.diploma"
            :onRemove="handleGraduationCertRemove"
            :onChange="handleGraduationCertChange"
            :rules="graduationCertRules"
            :limit="1"
          />
          <upload-field
            label="教资证书"
            prop="teachCertificate"
            :fileList="formData.teachCertificate"
            :onRemove="handleTeachingCertRemove"
            :onChange="handleTeachingCertChange"
            :rules="teachingCertRules"
            :limit="1"
          />
          <upload-field
            label="普通话证书"
            prop="mandarinCertificate"
            :fileList="formData.mandarinCertificate"
            :onRemove="handleMandarinCertRemove"
            :onChange="handleMandarinCertChange"
            :rules="mandarinCertRules"
            :limit="1"
          />
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitForm">确定</el-button>
        </span>
      </el-dialog>

      <!-- 重置密码 -->
      <el-dialog
        title="重置密码"
        :visible.sync="changePasswordDialogVisible"
        width="550px"
        @close="resetChangePasswordForm"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="changePasswordForm"
          ref="changePasswordForm"
          :rules="changePasswordRules"
          label-width="100px"
        >
          <el-form-item label="新密码" prop="password">
            <el-input
              v-model="changePasswordForm.password"
              placeholder="请输入新密码"
              style="width: 350px"
            />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="changePasswordDialogVisible = false"
            >取 消</el-button
          >
          <el-button type="primary" @click="submitChangePasswordForm"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {
  staffList,
  rolePage,
  fileUpload,
  staffDetail,
  staffAddOrEdit,
  staffDelete,
  userUnbind,
  adminChangePassWord,
} from "@/api/staff.js";
import { MAX_PAGE_SIZE, ethnicGroups } from "@/utils/const.js";
import { formatTime } from "@/utils/util";
import PaginationBar from "@/components/PaginationBar";
import UploadField from "@/components/UploadField";
import { mapState } from "vuex";

export default {
  components: {
    PaginationBar,
    UploadField,
  },
  computed: {
    ...mapState(["departmentList"]), // 从 Vuex 获取 userPermissions
  },
  data() {
    return {
      changePasswordDialogVisible: false,
      // 修改密码表单数据
      changePasswordForm: {
        password: "123456", //默认密码
        userId: "", //用户id
      },
      // 修改密码表单校验规则
      changePasswordRules: {
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
        ],
      },
      ethnicGroups: ethnicGroups,
      dialogVisible: false,
      isEdit: false,
      diploma_src: "", // 毕业证书---数据提交
      teachCertificate_src: "", // 教资证书---数据提交
      mandarinCertificate_src: "", // 普通话证书---数据提交
      formData: {
        name: "",
        roleId: "",
        deptId: "",
        sex: 2, // 修改为默认值"女"
        cardNo: "",
        ethnic: "",
        birthday: "",
        joiningTime: "",
        mobile: "",
        graduateSchool: "",
        major: "",
        education: "",
        mandarinLevel: "",
        password: "123456",
        isRepair: 0, // 默认"否"（不是维修人员）
        isAllocation: 0, // 默认"否"（不是分配主任）
        state: 1, // 默认"正常
        diploma: [], // 毕业证书
        teachCertificate: [], // 教资证书
        mandarinCertificate: [], // 普通话证书
      },
      positionOptions: [], // 示例
      departmentOptions: [],
      graduationCertRules: [
        { required: false, message: "请上传毕业证书", trigger: "change" },
      ],
      teachingCertRules: [
        { required: false, message: "请上传教资证书", trigger: "change" },
      ],
      mandarinCertRules: [
        { required: false, message: "请上传普通话证书", trigger: "change" },
      ],
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        roleId: [{ required: true, message: "请选择职务", trigger: "change" }],
        deptId: [{ required: true, message: "请选择部门", trigger: "change" }],
        sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        cardNo: [
          { required: false, message: "请输入身份证号", trigger: "blur" },
        ],
        ethnic: [{ required: false, message: "请输入民族", trigger: "blur" }],
        birthday: [
          { required: false, message: "请选择出生日期", trigger: "change" },
        ],
        joiningTime: [
          { required: false, message: "请选择入职时间", trigger: "change" },
        ],
        mobile: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入有效的手机号",
            trigger: "blur",
          },
        ],
        graduateSchool: [
          { required: false, message: "请输入毕业院校", trigger: "blur" },
        ],
        major: [{ required: false, message: "请输入专业", trigger: "blur" }],
        education: [
          { required: false, message: "请输入学历", trigger: "blur" },
        ],
        mandarinLevel: [
          { required: false, message: "请输入普通话等级", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        isRepair: [
          { required: true, message: "请选择是否维修人员", trigger: "change" },
        ],
        isAllocation: [
          { required: true, message: "请选择是否分配主任", trigger: "change" },
        ],
        state: [{ required: true, message: "请选择状态", trigger: "change" }],
        diploma: [
          { required: false, message: "毕业证书是必填项", trigger: "change" },
        ],
        teachCertificate: [
          { required: false, message: "教资证书是必填项", trigger: "change" },
        ],
        mandarinCertificate: [
          { required: false, message: "普通话证书是必填项", trigger: "change" },
        ],
      },
      queryParams: {
        name: "",
        roleName: "",
        departmentName: "",
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      allData: [], // 模拟数据池
    };
  },
  created() {
    this.handleQuery();
    this.getRolePage();
  },
  methods: {
    setPassword(row) {
      this.changePasswordForm.userId = row.id;
      this.changePasswordDialogVisible = true;
    },
    // 表单提交
    submitChangePasswordForm() {
      this.$refs.changePasswordForm.validate((valid) => {
        if (valid) {
          adminChangePassWord(this.changePasswordForm)
            .then(() => {
              this.$message.success("密码重置成功");
              this.changePasswordDialogVisible = false;
            })
            .catch(() => {
              this.$message.error("密码重置失败");
            });
        } else {
          return false;
        }
      });
    },
    resetChangePasswordForm() {
      this.$refs.changePasswordForm.resetFields();
      this.changePasswordForm = {
        password: "123456", //默认密码
        userId: "", //用户id
      };
    },
    resetForm() {
      // 重置表单及校验状态
      this.$refs.form.resetFields();

      // 重置 formData 数据
      this.formData = {
        name: "",
        roleId: "",
        deptId: "",
        sex: 2, // 修改为默认值"女"
        cardNo: "",
        ethnic: "",
        birthday: "",
        joiningTime: "",
        mobile: "",
        graduateSchool: "",
        major: "",
        education: "",
        mandarinLevel: "",
        password: "123456",
        isRepair: 0,
        isAllocation: 0,
        state: 1,
        diploma: [],
        teachCertificate: [],
        mandarinCertificate: [],
      };

      // 重置证书相关变量
      this.diploma_src = "";
      this.teachCertificate_src = "";
      this.mandarinCertificate_src = "";
    },
    // 请求所有的角色
    getRolePage() {
      rolePage({
        pageNo: 1,
        pageSize: MAX_PAGE_SIZE,
      })
        .then((res) => {
          this.positionOptions = res.records.map((item) => {
            return {
              value: item.id,
              label: item.name,
            };
          });
        })
        .catch((err) => {
          console.error("请求失败：", err);
        });
    },
    handleQuery(page) {
      this.currentPage = page || 1;
      const params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        ...this.queryParams,
      };
      staffList(params)
        .then((res) => {
          this.total = res.total;
          this.tableData = res.records;
        })
        .catch((err) => {
          console.error("请求失败：", err);
        });
    },
    resetQuery() {
      this.queryParams = { name: "", roleName: "", departmentName: "" };
      this.currentPage = 1;
      this.handleQuery();
    },
    openAddDialog() {
      // 请求数据
      this.isEdit = false;
      this.dialogVisible = true;
    },
    openEditDialog(row) {
      this.isEdit = true;
      //  console.log(row);
      // 请求详情接口
      staffDetail({ userId: row.id }).then((res) => {
        console.log(res);
        this.formData = res;
        // 处理要提交的数据
        this.diploma_src = res.diploma;
        this.teachCertificate_src = res.teachCertificate;
        this.mandarinCertificate_src = res.mandarinCertificate;

        this.formData.diploma = res.diploma
          ? res.diploma
              .split(",")
              .map((url) => ({ name: url.split("/").pop(), url }))
          : [];

        this.formData.teachCertificate = res.teachCertificate
          ? res.teachCertificate
              .split(",")
              .map((url) => ({ name: url.split("/").pop(), url }))
          : [];

        this.formData.mandarinCertificate = res.mandarinCertificate
          ? res.mandarinCertificate
              .split(",")
              .map((url) => ({ name: url.split("/").pop(), url }))
          : [];

        // 需要单独处理附件的展示不？
        this.dialogVisible = true;
      });
    },
    deleteUser(row) {
      this.$confirm("确定删除该员工？", "提示", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        staffDelete({ userId: row.id })
          .then(() => {
            this.$message.success("删除成功！");
            this.handleQuery();
          })
          .catch(() => {
            this.$message.success("操作失败");
          });
      });
    },
    unbind(row) {
      userUnbind({ userId: row.id }).then(() => {
        this.$message.success(`解绑成功：${row.name}`);
        this.handleQuery();
      });
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const { birthday, joiningTime } = this.formData;
          const params = { ...this.formData };
          params.birthday = birthday ? formatTime(birthday) : "";
          params.joiningTime = joiningTime ? formatTime(joiningTime) : "";
          // 三个证书地址
          params.diploma = this.diploma_src;
          params.mandarinCertificate = this.mandarinCertificate_src;
          params.teachCertificate = this.teachCertificate_src;

          // 提交到后端逻辑
          console.log("提交的表单数据：", this.formData, params);
          staffAddOrEdit(params)
            .then(() => {
              this.$message.success("操作成功");
              this.dialogVisible = false;
              // 更新列表
              this.handleQuery();
            })
            .catch((error) => {
              this.$message.error(error);
            });
        }
      });
    },
    handleGraduationCertRemove(file, fileList) {
      console.log("毕业证书删除:", file);
      this.formData.diploma = fileList;
    },
    handleGraduationCertChange(file, fileList) {
      this.formData.diploma = fileList;
      this.uploadFile(file, "diploma_src");
    },
    async uploadFile(file, type) {
      const formData = new FormData();
      formData.append("file", file.raw); // 将当前文件添加到 FormData 中

      try {
        // 调用文件上传接口
        const res = await fileUpload(formData);
        // 这里直接返回的是url
        this[type] = res;
        // 将更新后的文件列表返回给父组件
      } catch (error) {
        console.error("File upload failed: ", error);
        this.$message.error("文件上传失败，请重试");
      }
    },
    handleTeachingCertRemove(file, fileList) {
      this.formData.teachCertificate = fileList;
    },
    handleTeachingCertChange(file, fileList) {
      this.formData.teachCertificate = fileList;
      this.uploadFile(file, "teachCertificate_src");
    },
    handleMandarinCertRemove(file, fileList) {
      this.formData.mandarinCertificate = fileList;
    },
    handleMandarinCertChange(file, fileList) {
      this.uploadFile(file, "mandarinCertificate_src");
      this.formData.mandarinCertificate = fileList;
    },
  },
};
</script>

<style scoped>
.app-container {
}
.dialog-footer {
  text-align: right;
}
</style>

<style scoped>
.custom-dialog >>> .el-dialog {
  margin-top: 20px !important; /* 控制弹窗距离顶部位置 */
  max-height: 90vh;
  overflow-y: auto;
}
</style>
